import WsProvider from './provider/WSProvider'

var base64 = require('base64_js');

var serviceName = "controller";
var controllerService = {

    resimYukle(modul,name, base) {
        var userData3H = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userData3H"))));
        var param = {
            data: {
                yonetimId: userData3H["yonetimId"],
                userToken: userData3H["token"],
                firmaKodu: userData3H["firmaKodu"],
                modul: modul,
                name: name,
                base: base,
                methodName: "resimyukle",
            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;
    },
    sunucuResim(modul) {
        var userData3H = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userData3H"))));
        var param = {
            data: {
                yonetimId: userData3H["yonetimId"],
                userToken: userData3H["token"],
                firmaKodu: userData3H["firmaKodu"],
                modul: modul,
                methodName: "sunucuResim",
            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;
    },

    belgeYukle(modul,name, base) {
        var userData3H = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userData3H"))));
        var param = {
            data: {
                yonetimId: userData3H["yonetimId"],
                userToken: userData3H["token"],
                firmaKodu: userData3H["firmaKodu"],
                modul: modul,
                name: name,
                base: base,
                methodName: "belgeyukle",
            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;
    },
    sunucuBelge(modul) {
        var userData3H = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userData3H"))));
        var param = {
            data: {
                yonetimId: userData3H["yonetimId"],
                userToken: userData3H["token"],
                firmaKodu: userData3H["firmaKodu"],
                modul: modul,
                methodName: "sunucuBelge",
            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;
    }
};
export default controllerService



